// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__6IZws","primary":"Button_primary__hp-W8","soft":"Button_soft__Q-X3T","plain":"Button_plain__dyOoP"};